/*
 * jQuery filters plugin
 */
;(function($) {
  function CategoryFilters(options) {
    this.options = $.extend({
      categoryAttr: 'data-category',
      filterLinks: 'a.filter-link',
      filterBoxes: '.result',
      activeClass: 'active',
      addToParent: false,
      effect: 'slide',
      animSpeed: 500,
      animateSimultaneously: true,
      visibleAllBoxes: false,
      hiddenClass: 'hidden-state',
      event:'click'
    }, options);
    this.init();
  }

  CategoryFilters.prototype = {
    init: function () {
      if (this.options.holder) {
        this.findElements();
        this.attachEvents();
        this.makeCallback('onInit', this);
      }
    },
    findElements: function() {
      this.holder = jQuery(this.options.holder);
      this.filterLinks = this.holder.find(this.options.filterLinks);
      this.filterBoxes = this.holder.find(this.options.filterBoxes);
    },
    attachEvents: function() {
      var self = this;

      this.eventHandler = function(e) {
        e.preventDefault();
        self.curLink = jQuery(this);
        var activeHolder = self.options.addToParent ? self.curLink.parent() : self.curLink;


        if (activeHolder.hasClass(self.options.activeClass)){
          self.curLinkPrev = self.curLink;
          self.curLink = null;
        }
        if (self.curLink) {
          self.refreshClasses();
          self.applyFilter();
         }

        self.makeCallback('onBeforeChange', self);

      };
      this.filterLinks.on(this.options.event, this.eventHandler);
    },
    showBox: function(items, anim, callback) {
      var self = this,
      counter = 0;

      items.removeClass(this.options.hiddenClass);
      animateEffects[this.options.effect].show({
        item: items,
        animSpeed: anim,
        complete: function() {
          counter++;
          if (counter === items.length && jQuery.isFunction(callback)){
            callback();
          }
        }
      });
    },
    hideBox: function(items, anim, callback) {
      var self = this,
      counter = 0;

      items.addClass(this.options.hiddenClass);
      animateEffects[this.options.effect].hide({
        item: items,
        animSpeed: anim,
        complete: function() {
          counter++;
          if (counter === items.length && jQuery.isFunction(callback)){
            callback();
          }
        }
      });
    },
    findBoxes: function() {
      var visibleBoxes,
        hideBoxes,
        categoryName;

      if (this.curLink) {
        categoryName = this.curLink.attr(this.options.categoryAttr);
      } else {
        categoryName = '*';
      }

      if (categoryName === '*') {
        visibleBoxes = this.filterBoxes;
      } else {
        visibleBoxes = this.filterBoxes.filter('.' + categoryName);
      }

      hideBoxes = this.filterBoxes.not(visibleBoxes);

      return {
        visibleBoxes: visibleBoxes,
        hideBoxes: hideBoxes
      };
    },
    applyFilter: function(initial) {
      var self = this,
        resultBoxes = this.findBoxes(),
        animSpeed = initial ? 0 : this.options.animSpeed;

      if ($.isFunction(this.options.customFiltering)) {
        this.options.customFiltering(this, resultBoxes);
        return;
      }

      if (this.options.animateSimultaneously){
        this.hideBox(resultBoxes.hideBoxes, animSpeed);
        this.showBox(resultBoxes.visibleBoxes, animSpeed);
      } else {
        if (!resultBoxes.hideBoxes.length){
          self.showBox(resultBoxes.visibleBoxes, animSpeed);
        } else {
          this.hideBox(resultBoxes.hideBoxes, animSpeed, function() {
            self.showBox(resultBoxes.visibleBoxes, animSpeed);
          });
        }
      }
    },
    refreshClasses: function() {
      var activeHolder;

      if (this.options.addToParent) {
        this.filterLinks.parent().removeClass(this.options.activeClass);
      } else {
        this.filterLinks.removeClass(this.options.activeClass);
      }

      if (this.curLink) {
        activeHolder = this.options.addToParent ? this.curLink.parent() : this.curLink;
        activeHolder.addClass(this.options.activeClass);
      }
    },
    makeCallback: function(name) {
      var args;
      if (typeof this.options[name] === 'function') {
        args = Array.prototype.slice.call(arguments);
        args.shift();
        this.options[name].apply(this, args);
      }
    }
  };

  var animateEffects = {
    slide: {
      show: function(o) {
        o.item.stop(true).slideDown(o.animSpeed, o.complete);
      },
      hide: function(o) {
        o.item.stop(true).slideUp(o.animSpeed, o.complete);
      }
    },
    fade: {
      show: function(o) {
        o.item.stop(true).fadeIn(o.animSpeed, o.complete);
      },
      hide: function(o) {
        o.item.stop(true).fadeOut(o.animSpeed, o.complete);
      }
    },
    none: {
      show: function(o) {
        o.item.hide().show(0, o.complete);
      },
      hide: function(o) {
        o.item.hide(0, o.complete);
      }
    }
  };

  // jQuery plugin interface
  $.fn.categoryFilters = function(opt) {
    return this.each(function() {
      jQuery(this).data('CategoryFilters', new CategoryFilters($.extend(opt, { holder: this })));
    });
  };
}(jQuery));